var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserAdd = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.5,139c0-76.8,62.3-139,139-139s139,62.3,139,139s-62.3,139-139,139S111.5,215.8,111.5,139z M7.1,479.7 c0-107,86.7-193.7,193.7-193.7H300c107,0,193.7,86.7,193.7,193.7c0,17.9-14.4,32.3-32.3,32.3H39.4C21.6,511.9,7.1,497.5,7.1,479.7z M485.1,356.3v-69.5h-69.5c-14.4,0-26.1-11.6-26.1-26.1c0-14.4,11.6-26.1,26.1-26.1h69.5v-69.5c0-14.4,11.6-26.1,26.1-26.1 c14.4,0,26.1,11.6,26.1,26.1v69.5h69.5c14.4,0,26.1,11.6,26.1,26.1c0,14.4-11.6,26.1-26.1,26.1h-69.5v69.5 c0,14.4-11.6,26.1-26.1,26.1C496.8,382.5,485.1,370.8,485.1,356.3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/UserAdd.11a94fd3b59f2849353211fbeec2f3bb.svg";